import * as React from 'react';
import Svg, {Path} from 'react-native-svg';
import Styles from 'src/components/Styles';

function ChangeEmail() {
  return (
    <Svg width={24} height={24} viewBox="0 0 24 24" fill="none">
      <Path
        d="M5.25 7.625a.554.554 0 00-.563.542v.748l6.065 4.794a2.025 2.025 0 002.5 0l6.06-4.794v-.748a.554.554 0 00-.562-.542H5.25zm-.563 3.392v5.816c0 .298.254.542.563.542h13.5c.31 0 .563-.244.563-.542v-5.816l-4.993 3.948a3.766 3.766 0 01-4.64 0l-4.992-3.948zM3 8.167C3 6.972 4.009 6 5.25 6h13.5C19.991 6 21 6.972 21 8.167v8.666C21 18.028 19.991 19 18.75 19H5.25C4.009 19 3 18.028 3 16.833V8.167z"
        fill={Styles.Colors.PayNew.black01}
      />
    </Svg>
  );
}

const ChangeEmailIcon = React.memo(ChangeEmail);

export default ChangeEmailIcon;
